import { useEffect, useState } from 'react';
import {
  AppDatePicker,
  AppMultiSelect,
  AppRemixIcon,
  AppTextArea,
  AppModal,
  AppNoInfo,
  AppDeleteModal,
} from '@/layout/AppComponents';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Formik } from 'formik';
import ReactDOMServer from 'react-dom/server';
import { createPortal } from 'react-dom';
import styled from 'styled-components';
import { axiosPath } from '../../../../../../../routing/helpers/router';
import * as currentPageAction from '../../../../../../../store/actions/currentPageAction';
import NotificationAlert from '../../../../../../components/helpers/notificationAlert';
import Translator from '../../../../../../components/helpers/Translator';
import EvidenceNewForm from '../Evidence/EvidenceNewForm';
import minions from '../../../../../../../minions/minions';
import errorHandler from '@/layout/components/error/ErrorHandler';
import _ from 'lodash';

const CalendarEditEvent = (props) => {
  const { plantObligationID, onCreated, selectedEvent } = props;
  const { moduleBridgeHex, plantHex } = useParams();
  const dispatch = useDispatch();
  const permissions = useSelector((s) => s.module[moduleBridgeHex].permissions);
  const poLevel3 = useSelector(
    (s) => s.currentPage?.plantObligationLevels?.level3
  );
  const evidences = useSelector(
    (s) => s.currentPage?.evidenceTabs?.[plantObligationID]
  );
  const [showEventDeleteModal, setShowEventDeleteModal] = useState(false);
  const [showCreateEvidenceModal, setShowCreateEvidenceModal] = useState(false);
  const [isCreatingEvidence, setIsCreatingEvidence] = useState(false);
  // > LOAD EVIDENCE TAB
  const loadEvidenceTab = async () => {
    try {
      const response = await axios.post(
        axiosPath("api_r_user_module_legalCompliance_evidences_tab"),
        {
          moduleBridgeHex,
          plantHex,
          plantObligationID,
        }
      );
      return response.data;
    } catch (err) {}
  };
  useEffect(() => {
    if (evidences === undefined) {
      loadEvidenceTab().then((r) => {
        dispatch(
          currentPageAction.change("evidenceTabs", { [plantObligationID]: r })
        );
      });
    }
  }, []);
  // < LOAD EVIDENCE TAB

  // < EDIT EVENT
  const handleEditCalendarDate = async (values) => {
    try {
      const response = await axios.post(
        axiosPath("api_r_user_module_legalCompliance_calendar_edit"),
        {
          ...values,
          ...{
            moduleBridgeHex,
            plantHex,
            plantObligationID,
            calendarDateID: selectedEvent.id,
          },
        }
      );
      dispatch(
        currentPageAction.change("calendarTabs", {
          [plantObligationID]: response.data,
        })
      );
      onCreated(selectedEvent);
    } catch (err) {}
  };
  // > EDIT EVENT

  // < REMOVE DATE
  const handleRemoveCalendarDate = async () => {
    try {
      const response = await axios.post(
        axiosPath("api_r_user_module_legalCompliance_calendar_remove"),
        {
          moduleBridgeHex,
          plantHex,
          plantObligationID,
          calendarDateID: selectedEvent.id,
        }
      );
      dispatch(
        currentPageAction.change("calendarTabs", {
          [plantObligationID]: response.data,
        })
      );
      onCreated(null);
    } catch (err) {
      NotificationAlert({
        title: ReactDOMServer.renderToString(
          <Translator file="user" name="user.error" />
        ),
        message: ReactDOMServer.renderToString(
          <Translator file="module-legalCompliance" name="error.event.delete" />
        ),
        type: "danger",
        position: "top-center",
        duration: 0,
      });
    }
  };
  // > REMOVE DATE

  // < ADD EVIDENCE
  const handleAddEvidence = async (evidenceIDs, eventValues, setFieldValue) => {
    if (isCreatingEvidence) return;
    setIsCreatingEvidence(true);
    try {
      const response = await axios.post(
        axiosPath(
          "api_r_user_module_legalCompliance_calendar_createAttachEvidence"
        ),
        minions.forms.toFormData({
          ...eventValues,
          plantHex,
          plantObligationID,
        }),
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      dispatch(
        currentPageAction.change('evidenceTabs', {
          [plantObligationID]: response.data.evidences,
        })
      );
      if (permissions?.gcl?.module?.plant?.states?.needEvidenceToFulfilled) {
        const updatedLevel3 = { ...poLevel3 };
        updatedLevel3[plantObligationID].alerts.hasEvidences =
          response.data.hasEvidences;

        if (
          permissions?.gcl?.module?.plant?.states?.needEvidenceToFulfilled
            ?.needFile
        ) {
          updatedLevel3[plantObligationID].alerts.hasEvidencesWithFiles =
            response.data.hasEvidencesWithFiles;
        }

        dispatch(
          currentPageAction.change('plantObligationLevels', {
            level3: updatedLevel3,
          })
        );
      }
      const updatedEvidenceIDs = [...evidenceIDs];
      updatedEvidenceIDs.push(response.data.createdEvidenceID);
      setFieldValue('evidenceIDs', updatedEvidenceIDs);
      setIsCreatingEvidence(false);
      setShowCreateEvidenceModal(false);
    } catch (err) {
      setIsCreatingEvidence(false);
      setShowCreateEvidenceModal(false);
      dispatch(errorHandler(err));
    }
  };
  // < ADD EVIDENCE

  if (evidences === undefined) return <AppNoInfo minHeight={300} />;

  return (
    <>
      <h3>
        <Translator file="module-legalCompliance" name="edit.event" />{' '}
        {selectedEvent.date}
      </h3>
      <Formik
        validateOnChange={false}
        validateOnBlur={false}
        enableReinitialize
        initialValues={{
          date: selectedEvent.date,
          comment: selectedEvent.comment || '',
          evidenceIDs: evidences
            ? _.map(
                evidences.filter((e) =>
                  _.map(selectedEvent.evidences, 'id').includes(e.id)
                ),
                'id'
              )
            : '',
          evidencesDate: false,
        }}
        onSubmit={handleEditCalendarDate}
      >
        {({ setFieldValue, handleSubmit, values }) => (
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12">
                <AppDatePicker
                  title={ReactDOMServer.renderToString(
                    <Translator file="module-legalCompliance" name="date" />
                  )}
                  value={values.date}
                  onChange={(opt) => setFieldValue('date', opt)}
                  placeholder="dd/mm/yyyy"
                  popperClassName="react-datepicker-popper-100"
                  popperContainer={({ children }) =>
                    createPortal(children, document.body)
                  }
                />
              </div>
            </div>
            {permissions?.gcl?.module?.plant?.evidences && (
              <div className="row">
                <div className="col-lg-12 d-flex flex-row mt-2 mb-2 flex-wrap">
                  <AppMultiSelect
                    title={ReactDOMServer.renderToString(
                      <Translator
                        file="module-legalCompliance"
                        name="attached.evidence"
                      />
                    )}
                    icon={<AppRemixIcon icon="apps-2" />}
                    value={values.evidenceIDs}
                    options={evidences}
                    onChange={(v) => setFieldValue('evidenceIDs', v)}
                    setLabelField="selectName"
                    setValueField="id"
                    isLoading={!evidences}
                    hasSearchBox
                    hasSelectOptions
                    allowSelectAll
                  />
                  <CreateLinkBtn
                    className="btn btn-sm btn-success"
                    onClick={() => setShowCreateEvidenceModal(true)}
                  >
                    <Translator
                      file="module-legalCompliance"
                      name="create.and.link"
                    />
                  </CreateLinkBtn>
                </div>
              </div>
            )}
            <div className="row">
              <div className="col-lg-12">
                <AppTextArea
                  title={ReactDOMServer.renderToString(
                    <Translator file="module-legalCompliance" name="comment" />
                  )}
                  icon={<AppRemixIcon icon="align-left" noVariants />}
                  onChange={(opt) => setFieldValue('comment', opt)}
                  value={values.comment}
                />
              </div>
            </div>
            <p
              onClick={() =>
                setFieldValue('evidencesDate', !values.evidencesDate)
              }
              className="pointer"
            >
              <AppRemixIcon
                icon={values.evidencesDate ? 'checkbox' : 'checkbox-blank'}
                className="mr-2"
              />
              <Translator
                file="module-legalCompliance"
                name="calendar.edit.event.date.to.evidence"
              />
            </p>
            <span
              className="btn btn-outline-danger"
              onClick={() => setShowEventDeleteModal(true)}
            >
              <Translator file="general" name="general.delete" />
            </span>
            <AppDeleteModal
              show={showEventDeleteModal}
              title={ReactDOMServer.renderToString(
                <Translator file="module-legalCompliance" name="delete.event" />
              )}
              onConfirm={() => handleRemoveCalendarDate()}
              onClose={() => setShowEventDeleteModal(false)}
            />
            <div className="float-right">
              <span
                className="btn btn-outline-light mr-2"
                onClick={() => onCreated(selectedEvent)}
              >
                <Translator file="user" name="user.cancel" />
              </span>
              <span className="btn btn-outline-info" onClick={handleSubmit}>
                <Translator file="general" name="general.update" />
              </span>
            </div>
            <AppModal
              title={ReactDOMServer.renderToString(
                <Translator
                  file="module-legalCompliance"
                  name="create.evidence"
                />
              )}
              show={showCreateEvidenceModal}
              size="lg"
              onClose={() => setShowCreateEvidenceModal(false)}
            >
              <EvidenceNewForm
                handleAddEvidence={(v) =>
                  handleAddEvidence(values.evidenceIDs, v, setFieldValue)
                }
              />
            </AppModal>
          </div>
        )}
      </Formik>
    </>
  );
};
export default CalendarEditEvent;

const CreateLinkBtn = styled.span`
  margin: 10px 0 10px 10px !important;
  line-height: 24px;
`;
